<div class="row">
    <div class="col-lg-6 col-xl-4">
        <div class="card card-box pt-4 mb-5">
            <div class="card-tr-actions">
                <button class="btn btn-sm btn-neutral-warning" tooltip="Send Message" type="button">
                    <span class="btn-wrapper--icon">
                        <fa-icon [icon]="['far', 'envelope']"></fa-icon>
                    </span>
                </button>
            </div>
            <div class="text-center">
                <div class="avatar-icon-wrapper rounded-circle m-0">
                    <div class="d-block p-0 avatar-icon-wrapper m-0 d-90">
                        <div class="rounded-circle overflow-hidden">
                            <img alt="..." class="img-fluid" src="assets/images/avatars/avatar4.jpg"/>
                        </div>
                    </div>
                </div>
                <h3 class="font-weight-bold mt-3">Leopold Magana</h3>
                <span class="badge mt-1 mb-4 badge-neutral-warning text-warning font-size-md px-4 py-1 h-auto">Idle for 5 minutes</span>
                <div class="mt-3 rounded mx-4 bg-secondary p-3">
                    <button class="btn d-50 m-2 p-0 btn-pill btn-github" tooltip="Github" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'github']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-50 m-2 p-0 btn-pill btn-instagram" tooltip="Instagram" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'instagram']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-50 m-2 p-0 btn-pill btn-google" tooltip="Google" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'google']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                </div>
                <div class="pt-3">
                    <ul class="nav nav-first nav-lg flex-column py-2">
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <div class="nav-link-icon">
                                    <fa-icon [icon]="['far', 'building']"></fa-icon>
                                </div>
                                <span>Dashboard</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link active">
                                <div class="nav-link-icon">
                                    <fa-icon [icon]="['far', 'question-circle']"></fa-icon>
                                </div>
                                <span>Layouts</span>
                                <div class="ml-auto badge badge-warning">512</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link disabled">
                                <div class="nav-link-icon">
                                    <fa-icon [icon]="['far', 'user-circle']"></fa-icon>
                                </div>
                                <span>Reports</span>
                            </a>
                        </li>
                        <li class="dropdown-divider"></li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <div class="nav-link-icon">
                                    <fa-icon [icon]="['far', 'object-group']"></fa-icon>
                                </div>
                                <span>Components</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <div class="nav-link-icon">
                                    <fa-icon [icon]="['far', 'chart-bar']"></fa-icon>
                                </div>
                                <span>Services</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
    <div class="col-lg-6 col-xl-4">
        <div class="card card-box p-4 mb-5">
            <div class="card-tr-actions">
                <button class="btn btn-sm btn-neutral-danger" tooltip="Send Message" type="button">
                    <span class="btn-wrapper--icon">
                        <fa-icon [icon]="['far', 'envelope']"></fa-icon>
                    </span>
                </button>
            </div>
            <div class="text-center">
                <div class="avatar-icon-wrapper rounded-circle m-0">
                    <div class="d-block p-0 avatar-icon-wrapper m-0 d-90">
                        <div class="rounded-circle overflow-hidden">
                            <img alt="..." class="img-fluid" src="assets/images/avatars/avatar5.jpg"/>
                        </div>
                    </div>
                </div>
                <h3 class="font-weight-bold mt-3">Boyd Hardin</h3>
                <span class="badge mt-1 mb-4 badge-neutral-danger text-danger font-size-md px-4 py-1 h-auto">Offline</span>
                <p class="mb-0 text-black-50">A wonderful serenity has taken possession of my entire soul.</p>
                <div class="pt-3">
                    <button class="btn d-50 m-2 p-0 btn-pill btn-github" tooltip="Github" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'github']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-50 m-2 p-0 btn-pill btn-instagram" tooltip="Instagram" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'instagram']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-50 m-2 p-0 btn-pill btn-google" tooltip="Google" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'google']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                </div>
                <div class="pt-3">
                    <ul class="nav nav-pills nav-pills-rounded font-weight-bold flex-column pt-3 px-3">
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <div class="nav-link-icon opacity-6 mr-2">
                                    <fa-icon [icon]="['far', 'keyboard']" class="mx-auto"></fa-icon>
                                </div>
                                <span>My Account</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link active">
                                <div class="nav-link-icon opacity-6 mr-2">
                                    <fa-icon [icon]="['far', 'object-group']" class="mx-auto"></fa-icon>
                                </div>
                                <span>Profile settings</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <div class="nav-link-icon opacity-6 mr-2">
                                    <fa-icon [icon]="['far', 'user-circle']" class="mx-auto"></fa-icon>
                                </div>
                                <span>Active tasks</span>
                                <div class="ml-auto badge badge-success">New</div>
                            </a>
                        </li>
                        <li class="nav-item text-left font-size-lg mt-4 font-weight-bold text-black nav-item--header">
                            <span>Other items</span>
                        </li>

                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <div class="nav-link-icon opacity-6 mr-2">
                                    <fa-icon [icon]="['far', 'building']" class="mx-auto"></fa-icon>
                                </div>
                                <span>Customers</span>
                            </a>
                        </li>
                        <li class="dropdown-divider"></li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <div class="nav-link-icon opacity-6 mr-2">
                                    <fa-icon [icon]="['far', 'eye']" class="mx-auto"></fa-icon>
                                </div>
                                <span>Statistics</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
    <div class="col-lg-12 col-xl-4">
        <div class="card card-box pt-4 mb-5">
            <div class="card-tr-actions">
                <button class="btn btn-sm btn-neutral-dark" tooltip="Send Message" type="button">
                    <span class="btn-wrapper--icon">
                        <fa-icon [icon]="['far', 'envelope']"></fa-icon>
                    </span>
                </button>
            </div>
            <div class="text-center">
                <div class="avatar-icon-wrapper rounded-circle m-0">
                    <div class="d-block p-0 avatar-icon-wrapper m-0 d-90">
                        <div class="rounded-circle overflow-hidden">
                            <img alt="..." class="img-fluid" src="assets/images/avatars/avatar7.jpg"/>
                        </div>
                    </div>
                </div>
                <div>
                    <span class="badge my-2 badge-neutral-success text-success font-size-md px-4 py-1 h-auto">Online</span>
                </div>
                <h3 class="font-weight-bold mt-3">Lacie-Mae Mckay</h3>
                <p class="mb-0 text-black-50">Senior Frontend Developer at <b>Google Inc.</b></p>
                <div class="pt-3">
                    <button class="btn d-50 m-2 p-0 btn-github" tooltip="Github" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'github']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-50 m-2 p-0 btn-instagram" tooltip="Instagram" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'instagram']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-50 m-2 p-0 btn-google" tooltip="Google" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'google']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                </div>
                <div class="d-flex p-4 bg-secondary card-footer mt-4 flex-wrap">
                    <div class="w-50 p-2">
                        <button class="btn card card-box text-left d-flex justify-content-center px-4 py-3 w-100"
                                type="button">
                            <div>
                                <i-feather class="h1 d-block mb-4 text-warning line-height-1"
                                           name="settings"></i-feather>
                                <div class="font-weight-bold font-size-lg text-black">Reports</div>
                                <div class="font-size-md mb-1 text-black-50">Monthly Stats</div>
                            </div>
                        </button>
                    </div>
                    <div class="w-50 p-2">
                        <button class="btn card card-box text-left d-flex justify-content-center px-4 py-3 w-100"
                                type="button">
                            <div>
                                <i-feather class="h1 d-block mb-4 text-success line-height-1" name="grid"></i-feather>
                                <div class="font-weight-bold font-size-lg text-black">Statistics</div>
                                <div class="font-size-md mb-1 text-black-50">Customers stats</div>
                            </div>
                        </button>
                    </div>
                    <div class="w-50 p-2">
                        <button class="btn card card-box text-left d-flex justify-content-center px-4 py-3 w-100"
                                type="button">
                            <div>
                                <i-feather class="h1 d-block mb-4 text-danger line-height-1" name="users"></i-feather>
                                <div class="font-weight-bold font-size-lg text-black">Projects</div>
                                <div class="font-size-md mb-1 text-black-50">Manage servers</div>
                            </div>
                        </button>
                    </div>
                    <div class="w-50 p-2">
                        <button class="btn card card-box text-left d-flex justify-content-center px-4 py-3 w-100"
                                type="button">
                            <div>
                                <i-feather class="h1 d-block mb-4 text-first line-height-1" name="layers"></i-feather>
                                <div class="font-weight-bold font-size-lg text-black">Tasks</div>
                                <div class="font-size-md mb-1 text-black-50">Pending items</div>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
